import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import H4 from 'UIComponents/elements/headings/H4';
import { jsx as _jsx } from "react/jsx-runtime";
const GenericErrorMessage = ({
  title,
  children
}) => /*#__PURE__*/_jsx(UIErrorMessage, {
  illustration: "errors/general",
  title: /*#__PURE__*/_jsx(H4, {
    children: title
  }),
  children: children
});
export default GenericErrorMessage;